 

import { Action } from '@ngrx/store';

// eslint-disable-next-line max-len
import { CustomerFertilizerStock, FertiliserOrderFormParameters, FertilizerStockRow, GetArticlesByCropAidsResponse, GetFertiliserOrderplanResponse, OrderLine } from '../../models';

export enum FertilisersActionTypes {
  GetFertiliserOrderplan = '[Fertilisers][API][Orderplan] Get fertilisers orderplan list',
  SilentlyGetFertiliserOrderplan = '[Fertilisers][API][Orderplan] Silently (without loading spinner) get fertilisers orderplan list',
  GetFertiliserOrderplanSuccess = '[Fertilisers][API][Orderplan] Get fertilisers orderplan list success',
  GetArticlesByCropAids = '[Fertilisers][API][Crop aid] Get articles by crop aid ids list',
  GetArticlesByCropAidsSuccess = '[Fertilisers][API][Crop aid] Get articles by crop aid ids list success',
  CreateOrderReceiptReport = '[Fertilisers][Overview] Create order receipt report',
  CreateOrder = '[Fertilisers][API] Create order',
  CreateOrderSuccess = '[Fertilisers][API] Create order success',
  ConfirmOrderForOverview = '[Fertilisers][Overview] Confirm order for overview V2',
  GetCustomerFertilizerStock = '[Fertilisers][Overview] Get customer fertilizer stock',
  SetCustomerFertilizerStock = '[Fertilisers][Overview] Set customer fertilizer stock',
  SaveCustomerFertilizerStock = '[Fertilisers][Overview] Save customer fertilizer stock',
  DeleteOrderLine = '[Fertilisers][Overview] Delete order line',
  DeleteOrderLines = '[Fertilisers][Overview] Delete order lines',
  SaveOrderLine = '[Fertilisers][Overview] Save order line',
  OptimizeOrderLine = '[Fertilisers][Overview] Optimize order line',
  SilentlyOptimizeOrderLine = '[Fertilisers][Overview] Silently (without loading spinner) optimize order line',
  ShowFertilizersOrderDialog = '[Fertilisers][Overview] Show fertilizers order dialog'
}

export class GetFertiliserOrderplan implements Action {
  readonly type = FertilisersActionTypes.GetFertiliserOrderplan;
}

export class SilentlyGetFertiliserOrderplan implements Action {
  readonly type = FertilisersActionTypes.SilentlyGetFertiliserOrderplan;
}

export class GetFertiliserOrderplanSuccess implements Action {
  readonly type = FertilisersActionTypes.GetFertiliserOrderplanSuccess;
  constructor(public readonly result: GetFertiliserOrderplanResponse) {}
}

export class ShowFertilizersOrderDialog implements Action {
  readonly type = FertilisersActionTypes.ShowFertilizersOrderDialog;
}

export class GetArticlesByCropAids implements Action {
  readonly type = FertilisersActionTypes.GetArticlesByCropAids;
}

export class GetArticlesByCropAidsSuccess implements Action {
  readonly type = FertilisersActionTypes.GetArticlesByCropAidsSuccess;
  constructor(public readonly result: GetArticlesByCropAidsResponse) {}
}

export class CreateOrderReceiptReport implements Action {
  readonly type = FertilisersActionTypes.CreateOrderReceiptReport;
}

export class CreateOrder implements Action {
  readonly type = FertilisersActionTypes.CreateOrder;
  constructor(public readonly fertiliserOrderFormParameters: FertiliserOrderFormParameters) {}
}

export class CreateOrderSuccess implements Action {
  readonly type = FertilisersActionTypes.CreateOrderSuccess;
  constructor(public readonly customerId: number, public readonly locationId: number) {}
}

export class ConfirmOrderForOverview implements Action {
  readonly type = FertilisersActionTypes.ConfirmOrderForOverview;
}

export class GetCustomerFertilizerStock implements Action {
  readonly type = FertilisersActionTypes.GetCustomerFertilizerStock;
  constructor() {}
}

export class SetCustomerFertilizerStock implements Action {
  readonly type = FertilisersActionTypes.SetCustomerFertilizerStock;
  constructor(public readonly customerFertilizerStock?: CustomerFertilizerStock) {}
}

export class SaveCustomerFertilizerStock implements Action {
  readonly type = FertilisersActionTypes.SaveCustomerFertilizerStock;

  constructor(public readonly fertilizerStockRows: FertilizerStockRow[], public readonly orderLineId?: number) {}
}

export class DeleteOrderLine implements Action {
  readonly type = FertilisersActionTypes.DeleteOrderLine;
  constructor(public readonly id: number) {}
}

export class DeleteOrderLines implements Action {
  readonly type = FertilisersActionTypes.DeleteOrderLines;
  constructor(public readonly ids: number[]) {}
}

export class SaveOrderLine implements Action {
  readonly type = FertilisersActionTypes.SaveOrderLine;
  constructor(public readonly orderLine: OrderLine, public readonly cropAidId: number) {}
}

export class OptimizeOrderLine implements Action {
  readonly type = FertilisersActionTypes.OptimizeOrderLine;
  constructor(public readonly orderLineId: number) {}
}

export class SilentlyOptimizeOrderLine implements Action {
  readonly type = FertilisersActionTypes.SilentlyOptimizeOrderLine;
  constructor(public readonly orderLineId: number) {}
}

export type FertilisersActions =
  | GetFertiliserOrderplan
  | SilentlyGetFertiliserOrderplan
  | GetFertiliserOrderplanSuccess
  | GetArticlesByCropAids
  | GetArticlesByCropAidsSuccess
  | CreateOrderReceiptReport
  | CreateOrder
  | CreateOrderSuccess
  | ConfirmOrderForOverview
  | GetCustomerFertilizerStock
  | SetCustomerFertilizerStock
  | SaveCustomerFertilizerStock
  | DeleteOrderLine
  | DeleteOrderLines
  | SaveOrderLine
  | OptimizeOrderLine
  | SilentlyOptimizeOrderLine
  | ShowFertilizersOrderDialog;
